import { render } from "./Buy.vue?vue&type=template&id=384c59d6&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=384c59d6&lang=scss&scoped=true"
import "./Buy.vue?vue&type=style&index=1&id=384c59d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384c59d6"]])

export default __exports__